<template>
  <landing-page label="factSheet.hepatitisA" labelColor="#603813" descColor="#603813" :eggImgObj="{ componentName: 'factsheet', imgName: 'hepatitisALandingImage', imgFormat: 'png' }" :starBackgroundObj="{ componentName: 'shared', imgName: 'starGroupIconLightBrownRight', imgFormat: 'svg' }" />

  <div id="infoGroup" style="width: 60vw" class="fact-sheet-subpages pt-16 text-2xl font-jost space-y-12 m-auto pb-24">
    <div>
      <div class="font-bold text-description">{{ t("factSheet.causativeAgent") }}</div>
      <div v-html="t('factSheet.causativeAgentDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.clinicalFeatures") }}</div>
      <div v-html="t('factSheet.clinicalFeaturesDesc')" class="space-y-5" />
    </div>

    <div>
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.hepatitisAClinicalFeatureList" :key="'hepatitisAClinicalFeature' + index">
          <li v-html="t(item.label) + ';'" />
        </template>
      </ul>
    </div>

    <div v-html="t('factSheet.noAllHaveSymptoms')" class="space-y-5" />
    <div v-html="t('factSheet.hepatitisADesc')" class="space-y-5" />

    <div>
      <div class="font-bold text-description">{{ t("factSheet.modeOfTransmission") }}</div>
      <div v-html="t('factSheet.modeOfTransmissionDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.incubationPeriod") }}</div>
      <div v-html="t('factSheet.incubationPeriodDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.management") }}</div>
      <div v-html="t('factSheet.managementDesc')" class="space-y-5" />
    </div>

    <div>
      <div class="font-bold text-description">{{ t("factSheet.prevention") }}</div>
      <div v-html="t('factSheet.preventionDesc')" class="space-y-5" />
    </div>

    <div>
      <ul class="bullet-big">
        <template v-for="(item, index) in factSheetStore.hepatitisAPreventionList" :key="'hepatitisAPrevention' + index">
          <li v-html="t(item.label)" />
        </template>
      </ul>
    </div>

    <div v-html="t('factSheet.improvedSanitation')" class="space-y-5" />

    <div>
      <ol>
        <template v-for="(item, index) in factSheetStore.hepatitisAImprovedSanitationList" :key="'hepatitisAImprovedSanitation' + index">
          <li class="mt-12 font-bold">{{ t(item.label) }}</li>
          <div class="text-description" v-if="item.desc">{{ t(item.desc) }}</div>
          <ul class="bullet-big space-y-12 mt-12">
            <template v-for="(listItem, idx) in item.list" :key="'hepatitisAImprovedSanitationItem' + index + idx">
              <li v-html="t(listItem)" />
            </template>
          </ul>
        </template>
      </ol>
    </div>

    <div v-html="t('factSheet.hepatitisARef')" class="mt-5" />

    <!-- Chinese Version -->
    <section class="!font-sanstc space-y-12">
      <div>
        <div class="font-bold text-description text-center text-4xl">{{ t("factSheetChinese.hepatitisA") }}</div>
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.causativeAgent") }}</div>
        <div v-html="t('factSheetChinese.causativeAgentDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.clinicalFeatures") }}</div>
        <div v-html="t('factSheetChinese.clinicalFeaturesDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.symptoms") }}</div>
        <div v-html="t('factSheetChinese.hepatitisASymptomsDesc')" class="space-y-5" />
      </div>

      <div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.hepatitisAClinicalFeatureList" :key="'hepatitisAClinicalFeature' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese')) + ';'" />
          </template>
        </ul>
      </div>

      <div v-html="t('factSheetChinese.noAllHaveSymptoms')" class="space-y-5" />

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.incubationPeriod") }}</div>
        <div v-html="t('factSheetChinese.incubationPeriodDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.management") }}</div>
        <div v-html="t('factSheetChinese.managementDesc')" class="space-y-5" />
      </div>

      <div>
        <div class="font-bold text-description">{{ t("factSheetChinese.prevention") }}</div>
        <div v-html="t('factSheetChinese.preventionDesc')" class="space-y-5" />
      </div>

      <div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.hepatitisAPreventionList" :key="'hepatitisAPrevention' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div v-html="t('factSheetChinese.improvedSanitation')" class="space-y-5" />

      <div>
        <ol>
          <template v-for="(item, index) in factSheetStore.hepatitisAImprovedSanitationList" :key="'hepatitisAImprovedSanitation' + index">
            <li class="mt-12 font-bold">{{ t(item.label.replace("factSheet", "factSheetChinese")) }}</li>
            <div class="text-description" v-if="item.desc">{{ t(item.desc.replace("factSheet", "factSheetChinese")) }}</div>
            <ul class="bullet-big space-y-12 mt-12">
              <template v-for="(listItem, idx) in item.list" :key="'hepatitisAImprovedSanitationItem' + index + idx">
                <li v-html="t(listItem.replace('factSheet', 'factSheetChinese'))" />
              </template>
            </ul>
          </template>
        </ol>
      </div>

      <div v-html="t('factSheetChinese.hepatitisAVaccinationDesc')" class="space-y-5" />

      <div>
        <ul class="bullet-big">
          <template v-for="(item, index) in factSheetStore.hepatitisAVaccinationList" :key="'hepatitisAVaccination' + index">
            <li v-html="t(item.label.replace('factSheet', 'factSheetChinese'))" />
          </template>
        </ul>
      </div>

      <div v-html="t('factSheetChinese.hepatitisARef')" class="mt-5" />
    </section>
  </div>
</template>

<script setup lang="ts">
import { useFactSheetStore } from "@/stores/factSheet";
import { useHeaderStore } from "@/stores/header";
import { computed, onMounted, ref, toRefs } from "vue";
import { useRouter } from "vue-router";
import { useI18n } from "vue-i18n";

const factSheetStore = useFactSheetStore();
const headerStore = useHeaderStore();
const router = useRouter();
const { t, locale } = useI18n();

onMounted(async () => {
  headerStore.routerName = 'factsheet';
});

//not on home page, stop intro timer
router.beforeEach(async (to, from) => {});

const goTo = (refName) => {};

const routeTo = (position) => {
  router.push({ name: position, params: { uid: "lczmx" } });
};
</script>